import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { Form, Input, InputNumber, Switch, Row, Col } from 'antd';

const perToken = (v: any) => {
  if (!v || v === '') return null;
  const num = parseFloat(String(v));
  if (isNaN(num)) return String(v);
  return String(num / 1_000_000);
};

const priceFields = ['promptPrice', 'completionPrice', 'inputCacheReadPrice', 'imagePrice', 'webSearchPrice', 'internalReasoningPrice'];

export const LlmModelCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'llm-models' });

  const handleSubmit = (values: any) => {
    for (const f of priceFields) {
      values[f] = perToken(values[f]);
    }
    return formProps.onFinish?.(values);
  };

  return (
    <Create resource="llm-models" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical" onFinish={handleSubmit}>
        <Form.Item label="Slug" name="slug" rules={[{ required: true }]} extra='Model ID, e.g. "openai/gpt-4o"'>
          <Input placeholder="openai/gpt-4o" />
        </Form.Item>
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input placeholder="GPT-4o" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={3} />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Context Length" name="contextLength">
              <InputNumber style={{ width: '100%' }} min={0} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Max Completion Tokens" name="maxCompletionTokens">
              <InputNumber style={{ width: '100%' }} min={0} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="Modality" name="modality" extra='e.g. "text->text", "text+image->text"'>
          <Input />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Tokenizer" name="tokenizer">
              <Input placeholder="GPT, Claude, etc." />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Instruct Type" name="instructType">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <h4>Pricing ($/1M tokens)</h4>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Prompt" name="promptPrice">
              <Input placeholder="0.065" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Completion" name="completionPrice">
              <Input placeholder="0.26" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Cache Read" name="inputCacheReadPrice">
              <Input placeholder="0.01" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Image" name="imagePrice">
              <Input placeholder="0" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Web Search" name="webSearchPrice">
              <Input placeholder="0" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Reasoning" name="internalReasoningPrice">
              <Input placeholder="0" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Active" name="isActive" valuePropName="checked" initialValue={true}>
              <Switch />
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item label="Provider" name="providerId">
              <Input placeholder="Provider UUID (optional)" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
